import React from 'react';
import { Search, ShieldCheck, MapPin, Wrench, Package } from 'lucide-react';
const CHIPS = [{
  label: 'Complete mailbox system',
  href: '/6m8/mailboxes/complete-mailbox-post-system.html'
}, {
  label: 'Locking mailbox',
  href: '/6m8/mailboxes/locking-mailboxes.html'
}, {
  label: 'Commercial CBU',
  href: '/6m8/commercial-mailboxes-lockers/centralized-delivery-mailboxes-and-kiosks.html'
}, {
  label: 'Replacement part',
  href: '/6m8/mailboxes/mailbox-replacement-parts-and-accessories.html'
}, {
  label: 'Address plaque',
  href: '/6m8/address-plaques-and-house-numbers.html'
}, {
  label: 'Mailbox post',
  href: '/6m8/mailbox-posts.html'
}];
export function Hero() {
  return <section className="relative bg-brand-background overflow-hidden border-b border-brand-border" data-id="element-343" data-mp="3ryhxz8krgxk3">
      <div className="max-w-7xl mx-auto px-4 py-8 lg:py-12" data-id="element-344" data-mp="1v3ltod76iwi0">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center" data-id="element-345" data-mp="1q5250517b6ly">
          {/* Left Column: Content */}
          <div className="lg:col-span-7 relative z-10" data-id="element-346" data-mp="1murjisedqc5k">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-goldSoft text-brand-charcoal text-xs font-bold tracking-wide mb-4 uppercase border border-brand-gold/30" data-id="element-347" data-mp="1rvyqwqcm19bp">
              Residential, commercial & custom mailbox systems
            </span>

            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-serif font-bold text-brand-charcoal mb-4 leading-tight text-balance" data-id="element-348" data-mp="1hz2pt5p1jph6">
              The Right Mailbox for Your Home, Community, or Business
            </h1>

            <p className="text-base lg:text-lg text-brand-muted mb-6 leading-relaxed text-balance max-w-2xl" data-id="element-349" data-mp="1vxag4urknsjd">
              Shop residential mailboxes, commercial delivery systems,
              replacement parts, address plaques, signs, lighting, and exterior
              accents — with expert help before you order.
            </p>

            {/* Hero Search Panel */}
            {/* TODO: wire form action to Website Forge search endpoint */}
            <form role="search" onSubmit={e => e.preventDefault()} className="bg-white p-2 rounded-lg shadow-sm border border-brand-border mb-3 flex flex-col sm:flex-row gap-2 max-w-2xl" data-id="element-350" data-mp="337vbjz3kjtlh">
              <div className="relative flex-grow" data-id="element-351" data-mp="2p8vvvgy1ap1g">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} data-id="element-352" data-mp="2p83xxzgysf80" />
                <input type="text" aria-label="Search 1,700+ products by name, brand, part, or spec" placeholder="Search 1,700+ products by name, brand, part, or spec" className="w-full pl-10 pr-4 py-3 rounded-md border-none focus:ring-2 focus:ring-brand-maroon/50 bg-transparent text-brand-charcoal placeholder-gray-500 font-medium" data-id="element-353" data-mp="2fiapv8g16i8i" />
              </div>
              <button type="submit" aria-label="Search" className="bg-brand-maroon hover:bg-brand-maroonDark text-white px-8 py-3 rounded-md font-semibold transition-colors whitespace-nowrap shadow-sm" data-id="element-354" data-mp="1wkgj712dkita">
                Search
              </button>
            </form>

            {/* Quick Chips */}
            <div className="flex flex-wrap gap-2 mb-8 max-w-2xl" data-id="element-355" data-mp="q1yoex4xowwe">
              {CHIPS.map(chip => <a key={chip.label} href={chip.href} className="text-xs font-medium bg-white hover:bg-brand-goldWash text-brand-muted hover:text-brand-charcoal hover:border-brand-gold px-3 py-1.5 rounded-full border border-brand-border transition-colors" data-id="element-356" data-mp="3phll78cz4c5u">
                  {chip.label}
                </a>)}
            </div>

            {/* CTAs */}
            <div className="flex flex-wrap items-center gap-4" data-id="element-357" data-mp="36q2il2mv304c">
              <a href="#shop-by-need" className="bg-brand-maroon hover:bg-brand-maroonDark text-white px-6 py-3 rounded-md font-bold transition-colors shadow-sm" data-id="element-358" data-mp="3aqur1tnwt0zk">
                Shop by Project
              </a>
              <a href="/ContactUs.html" className="bg-white hover:bg-brand-panel text-brand-charcoal border border-brand-border px-6 py-3 rounded-md font-semibold transition-colors" data-id="element-359" data-mp="31d43aw7hthkz">
                Get Help Choosing
              </a>
              <span className="hidden sm:inline text-gray-400" data-id="element-360" data-mp="3afvh32nucpfs">or</span>
              <a href="tel:301-620-7585" className="text-brand-charcoal hover:text-brand-maroon font-semibold flex items-center gap-2 transition-colors" data-id="element-361" data-mp="35dwh82rb8anl">
                Call 301-620-7585
              </a>
            </div>
          </div>

          {/* Right Column: Image */}
          <div className="lg:col-span-5 relative hidden lg:block h-full min-h-[440px]" data-id="element-362" data-mp="1q01nw4h4qy2e">
            <div className="absolute inset-0 rounded-2xl overflow-hidden shadow-sm border border-brand-border" data-id="element-363" data-mp="1l0p27n1zvx1e">
              <img src="https://cdn.magicpatterns.com/uploads/vFqrVUQeADTTrZFkvijeyA/01-hero-mailbox-scene.png" alt="Black residential mailbox in front of a landscaped home." className="w-full h-full object-cover object-center" data-id="element-364" data-mp="iwmpc5hrnhn" />
            </div>
          </div>
        </div>
      </div>

      {/* Trust Strip - Compact */}
      <div className="bg-white border-t border-brand-border" data-id="element-365" data-mp="3dueuz85lpbkg">
        <div className="max-w-7xl mx-auto px-4 py-3" data-id="element-366" data-mp="3hxjvx6a1956z">
          <div className="flex flex-wrap justify-center lg:justify-between items-center gap-x-8 gap-y-3 text-xs lg:text-sm text-brand-charcoal font-medium" data-id="element-367" data-mp="3huytog5ton8p">
            <div className="flex items-center gap-2" data-id="element-368" data-mp="38xeowx8r48tc">
              <Package size={16} className="text-brand-maroon" data-id="element-369" data-mp="1265qx3zmjtwi" />
              <span data-id="element-370" data-mp="126yqnl061j55">Nationwide shipping</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-brand-border" data-id="element-371" data-mp="175icllereuxi"></div>
            <div className="flex items-center gap-2" data-id="element-372" data-mp="15ntl3584j287">
              <Wrench size={16} className="text-brand-maroon" data-id="element-373" data-mp="15peegripcf4h" />
              <span data-id="element-374" data-mp="10oqmo3mnfu97">Select-area installation</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-brand-border" data-id="element-375" data-mp="vpxb4gqxadbo"></div>
            <div className="flex items-center gap-2" data-id="element-376" data-mp="vrzyet0oxscp">
              <ShieldCheck size={16} className="text-brand-maroon" data-id="element-377" data-mp="qrlwzttlhgnn" />
              <span data-id="element-378" data-mp="1oekxkfner8qt">22+ years of expertise</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-brand-border" data-id="element-379" data-mp="1odt2r71mxf1l"></div>
            <div className="flex items-center gap-2" data-id="element-380" data-mp="1jgsy90kfokcl">
              <MapPin size={16} className="text-brand-maroon" data-id="element-381" data-mp="1eormdfr6gvn3" />
              <span data-id="element-382" data-mp="1emyi2741eni9">USPS-aware guidance</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}